if (!customElements.get('footer-floater')) {
  customElements.define('footer-floater', class extends HTMLElement {
    connectedCallback() {
      const button = this.querySelector('button');
      if (!button || this.initialized) return;
      this.initialized = true;
      button.hidden = false;
      button.addEventListener('click', () => {
        const paused = this.toggleAttribute('data-paused');
        button.setAttribute('aria-pressed', String(paused));
        button.textContent = paused ? 'Resume image movement' : 'Pause image movement';
      });
    }
  });
}
